import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Instructor } from "../../types/types";

type InstructorsDTO = Instructor
type InstructorResponse = {
    data: object;
} & ApiError;
export const AddInstructor = (
    data: InstructorsDTO
): Promise<InstructorResponse> => {
    return axios.post("/instructor/create", data);
};
